import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  ORDER_EVENTS,
  sendClubbedOrderEvents,
} from '../../../helpers/analytics/order.analytics';
import { Tabs } from '../../../UiKit';

const links = [
  {
    title: 'Main Order',
    tab: 'parent',
  },
  {
    title: 'Additional Order',
    tab: 'child',
  },
];

export const OrderTabs = ({
  relation = 'parent',
  orderId = null,
  userId = null,
  handleTabChange = () => {},
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  useEffect(() => {
    getDefaultActiveTab();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relation]);

  const getDefaultActiveTab = () => {
    var iterator = links.entries();

    for (const [index, item] of iterator) {
      if (item.tab === relation) {
        setActiveTabIndex(index);
        sendClubbedOrderEvents(
          ORDER_EVENTS.SELECT_CLUBBER_ORDER_TAB_EVENT,
          orderId,
          userId,
          {
            order_type: String(item.title),
            order_id: String(orderId),
          },
        );
        return;
      }
    }
  };

  const onTabSelection = (action, index) => {
    setActiveTabIndex(index);
    handleTabChange(action.tab);
  };

  return (
    <OrderTabs.Wrapper>
      <Tabs
        activeIndex={activeTabIndex}
        links={links}
        width='40rem'
        setActiveAction={onTabSelection}
      />
    </OrderTabs.Wrapper>
  );
};

OrderTabs.Wrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #ebebeb;
  padding-left: 2rem;
`;
